import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import { Box } from '@mui/material';
import Footer from '../../components/Footer/Footer';
import PopupCard from '../../components/event_page/PopupCard';


const EventPopupPageWithNav = () => {
	return (
		<Box>
			<Navbar />
			<PopupCard />
			<Footer />
		</Box>
	);
};

export default EventPopupPageWithNav;
